<template>
  <div class="crewHome">
    <div class="crewHome-content">
      <el-form :inline="true" :model="formInline" class="other-form-inline">
        <!-- <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            v-model="formInline.date1"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            v-model="formInline.date2"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="formInline.region"
            placeholder="是否加入人才储备"
            style="width: 165px"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-input
            v-model="formInline.positionName"
            placeholder="搜索职位"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
        <!-- <el-form-item>
          <div class="other-search" style="width: 100px" @click="inviteAdd()">
            <i class="iconfont icon-yaoqing"></i
            ><span style="font-size: 14px">邀请投递</span>
          </div>
        </el-form-item> -->
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == '0'">男</span>
              <span v-if="scope.row.sex == '1'">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="80">
          </el-table-column>
          <el-table-column prop="workingYear" label="航海经验" min-width="80">
          </el-table-column>
          <el-table-column prop="educationName" label="学历" min-width="80">
          </el-table-column>
          <el-table-column
            prop="clientCompanyName"
            label="投递公司"
            min-width="120"
          >
          </el-table-column>
          <el-table-column
            prop="sendPositionName"
            label="投递岗位"
            min-width="100"
          >
          </el-table-column>
          <el-table-column prop="" label="是否加入人才储备" min-width="130">
            <template slot-scope="scope">
              <span v-if="scope.row.agentCyJoinState == '1'">已加入</span>
              <span v-if="scope.row.agentCyJoinState != '1'">未加入</span>
            </template>
          </el-table-column>
          <el-table-column prop="operateTime" label="投递时间" min-width="100">
          </el-table-column>
          <el-table-column label="操作" min-width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>
              <!-- <el-button type="text" size="small" class="other-watch">
                下载
              </el-button> -->
              <el-button
                v-if="
                  scope.row.agentAuditState == null &&
                  scope.row.agentCyJoinState != '1'
                "
                type="text"
                size="small"
                class="other-green"
                @click="passInvite(scope)"
              >
                通过
              </el-button>
              <el-button
                v-if="
                  scope.row.agentAuditState == null &&
                  scope.row.agentCyJoinState != '1'
                "
                type="text"
                size="small"
                class="other-del"
                @click="delInvite(scope)"
              >
                淘汰
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      class="other-dialog"
      width="450px"
      title="审核通过"
      :visible.sync="companyVisible"
      ref="vueRef"
      :before-close="handleClose"
    >
      <el-form
        label-width="120px"
        :model="formLabelAlign"
        class="other-form"
        :rules="rules"
      >
        <el-form-item label="是否属于本公司" prop="userState">
          <el-select
            v-model="jobParams.userState"
            placeholder="是否属于本公司"
            :remote-method="remoteMethod"
          >
            <el-option label="是" value="1"> </el-option>
            <el-option label="否" value="2"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="船员类型" prop="crewType">
          <el-select
            v-model="jobParams.crewType"
            placeholder="招聘职位"
            style="width: 135px"
          >
            <el-option label="自有船员" value="1"> </el-option>
            <el-option label="借调船员" value="2"> </el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="other-footer">
        <el-button @click="companyVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rememendCrewPass()"
          :loading="remendLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { resumeManagement, crewAudit } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      tableData: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
      diaList: {},
      jobParams: {},
      companyVisible: false,
      remendLoading: false,
      rules: {
        // crewType: [
        //   { required: true, message: "请选择船员类型", trigger: "blur" },
        // ],
        userState: [
          {
            required: true,
            message: "请选择员工在本派遣机构状态",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getResumeManagement();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getResumeManagement();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getResumeManagement();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getResumeManagement();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      // console.log(scope);
      // let name = scope.row.date1;
      // console.log(name);
      if (!item.row.userName) {
        item.row.userName = "无姓名";
      }
      let params = {};
      if (
        item.row.agentAuditState == null &&
        item.row.agentCyJoinState != "1"
      ) {
        params.flag = "1";
      } else {
        params.flag = "2";
      }
      this.$router.push({
        name: "inviteDetail2",
        params: {
          name: item.row.userName,
          userId: item.row.userId,
          passFlag: params.flag,
          cyResumeSendId: item.row.sendId,
        },
      });
    },
    inviteAdd() {
      this.$router.push({ name: "inviteAdd", params: { name: "邀请投递" } });
    },
    async getResumeManagement() {
      let res = await resumeManagement({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        // userOrigin: "3",
        dataType: "1",
        ...this.formInline,
      });
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.tableData.forEach((item) => {
        if (item.operateTime) {
          item.operateTime = item.operateTime.split(" ")[0];
        }
      });
    },
    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },

    async delList(row) {
      await crewAudit({
        userId: row.userId,
        userOrigin: "3",
        agentAuditState: "3",
        cyResumeSendId: row.sendId,
      });
      // console.log(res);
      this.getResumeManagement();
    },
    passInvite(scope) {
      this.jobParams = {};
      this.diaList = scope.row;
      this.companyVisible = true;
    },
    rememendCrewPass() {
      if (!this.jobParams.userState) {
        this.$message({
          message: "请选择是否属于本公司",
          type: "error",
        });
        return;
      }
      this.remendLoading = true;
      this.addCrewList();
    },
    async addCrewList() {
      let res = await crewAudit({
        userState: this.jobParams.userState,
        crewType: this.jobParams.crewType,
        agentAuditState: "2",
        userId: this.diaList.userId,
        agentCyAuditId: this.diaList.agentCyAuditId,
        userOrigin: "3",
      });
      if (res.code == 1) {
        this.$message({
          message: "成功",
          type: "success",
        });
        this.remendLoading = false;
        this.companyVisible = false;
        this.getCrewInfoList();
        // this.$router.push({ name: "邀请船员" });
      } else {
        this.$message({
          message: res.msg,
          type: "warning",
        });
        this.remendLoading = false;
        this.companyVisible = false;
      }
      // console.log(res);
    },
  },
};
</script>
